/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class RenderTemporary extends Component {
  static propTypes = {
    callback: PropTypes.func,
    children: PropTypes.any,
    rendered: PropTypes.bool,
    timeout: PropTypes.number,
  };

  static defaultProps = {
    timeout: 1000,
  };

  state = {
    rendered: this.props.rendered || false,
  };

  constructor(props) {
    super(props);

    this.timeoutId = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rendered) {
      this.setState({ rendered: true }, () => {
        this.timeoutId = setTimeout(() => {
          this.setState({ rendered: false }, nextProps.callback);
        }, this.props.timeout);
      });
    } else {
      this.setState({ rendered: false });
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    return this.state.rendered ? this.props.children : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/RenderTemporary/index.jsx